import { api } from './index';

export const getDriverInfractions = async (
  productVersionIdRef,
  effectiveDt
) => {
  return await api.get(
    `/products/${productVersionIdRef}/driverInfractions?transactionEffectiveDt=${effectiveDt}`
  );
};
